import script from "./CapacitacionPrivadoView.vue?vue&type=script&setup=true&lang=js"
export * from "./CapacitacionPrivadoView.vue?vue&type=script&setup=true&lang=js"

import "./CapacitacionPrivadoView.vue?vue&type=style&index=0&id=0e56f4b0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e56f4b0"]])

export default __exports__